module.exports = __webpack_public_path__ + "img/金地集团.e2230d2a.png";